import {Subprocess, ProcessActions} from '../../constants/constants';
import {GroupListProps} from '../../constants/types';

export enum ProcessCode {
  RUNNING = 'RUNNING',
  CANCELLED = 'CANCELED',
  TERMINATED = 'TERMINATED',
  COMPLETED = 'COMPLETED'
}

export enum ProcessFilter {
  AHEAD = 'AHEAD',
  BEHIND = 'BEHIND'
}

export type UserProps = {
  id: number,
  firstName: string,
  lastName: string
}

export type TaskDetailsProps = {
  id: number,
  type: {
    code: string,
    description: string,
    detailedDesc: string
  },
  assignee: Nullable<UserProps>,
  process: {
    id: number,
    type: {
      code: string,
      description: string,
      allowManualStart: boolean
    }
  },
  startedAt: string,
  completedAt: Nullable<string>,
  targetTime: number,
  operatoryNumber: Nullable<number>,
  groupNames: string[],
  groups: {
    id: number,
    name: string,
    slug: string
  }[],
  status: {
    code: ProcessCode,
    description: string
  },
  seqNum: number
}

export type TasksDetailsResponseProps = TaskDetailsProps[]

export type SubprocessPopupData = {
  id: number,
  type: Subprocess,
  message: string,
  patientName: string
}

export type ProcessActionPopupData = {
  id: number,
  type: ProcessActions,
  message: string,
  confirmBtn: string,
  assigneeId: number
}

export type shouldShowClaimButtonProps = {
  availableProcessAssigneeGroups: Nullable<GroupListProps[]>,
  userGroups: Nullable<string[]>,
}

export type LatestSchedulingProcessProps = {
  id: number,
  startedSubProcesses: string[],
  status: string,
  type: string,
}
